"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizePhoneToE164 = exports.isE164PhoneNumber = exports.isNanpCountry = exports.maskPhoneNumber = void 0;
const libphonenumber_js_1 = require("libphonenumber-js");
const maskPhoneNumber = (phoneNumber) => {
    const digitsOnly = phoneNumber.replace(/\D/g, "");
    if (digitsOnly.length < 4) {
        return phoneNumber;
    }
    const maskedSection = "***-***";
    const lastFourDigits = digitsOnly.slice(-4);
    return `${maskedSection}-${lastFourDigits}`;
};
exports.maskPhoneNumber = maskPhoneNumber;
const NORTH_AMERICAN_ISO2_CODES = new Set(["US", "CA"]);
const isNanpCountry = (iso2Country) => NORTH_AMERICAN_ISO2_CODES.has(String(iso2Country).toUpperCase());
exports.isNanpCountry = isNanpCountry;
const E164_PATTERN = /^\+[1-9]\d{7,14}$/;
const isE164PhoneNumber = (value) => E164_PATTERN.test(value ?? "");
exports.isE164PhoneNumber = isE164PhoneNumber;
const toValidE164 = (parsed) => parsed?.isValid() ? parsed.number : null;
const normalizePhoneToE164 = (phone, iso2Country) => {
    if (!phone) {
        return null;
    }
    const digits = phone.replace(/\D/g, "");
    if (!digits) {
        return null;
    }
    if (phone.includes("+")) {
        return toValidE164((0, libphonenumber_js_1.parsePhoneNumberFromString)(`+${digits}`));
    }
    if ((0, exports.isNanpCountry)(iso2Country)) {
        const national = digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
        return /^[2-9]\d{9}$/.test(national) ? toValidE164((0, libphonenumber_js_1.parsePhoneNumberFromString)(`+1${national}`)) : null;
    }
    if (!iso2Country) {
        return null;
    }
    const country = iso2Country.toUpperCase();
    const withDialCode = (0, libphonenumber_js_1.parsePhoneNumberFromString)(`+${digits}`);
    if (withDialCode?.isValid() && withDialCode.country === country) {
        return withDialCode.number;
    }
    return toValidE164((0, libphonenumber_js_1.parsePhoneNumberFromString)(digits, country));
};
exports.normalizePhoneToE164 = normalizePhoneToE164;
